'use strict'

function markdownSpace(code) {
  return code === -2 || code === -1 || code === 32
}

module.exports = markdownSpace



//////////////////
// WEBPACK FOOTER
// ./node_modules/micromark/dist/character/markdown-space.js
// module id = 151
// module chunks = 0